import React from "react";
import { useState, useEffect } from 'react';
import apiFetcher from "../utils/apiFetcher";
import { scrollToClass } from "../utils/scroll";

const UserPanel = ({isLoggedIn, setIsLoggedIn, setIsActivePanel , isActivePanel, inProgress, points, setPoints,referralCode}) => {
    const [userData , setUserData] = useState({
        email: '',
        password: ''
    })
    // const [points, setPoints] = useState(0);
    const [error,setError] = useState(``)
    const [webToken, setWebToken] = useState();
    const handleInputChange = (e) => {
        const {id, value} = e.target;
        const newValue = value.trim();
        setUserData({...userData, [id]: newValue})
    }
    function parseToken(token) {
        return JSON.parse(atob(token.split('.')[1]));
    }

    const getPoints = async () => {
        const {id} = webToken;
        const {referralCode} = webToken;
        const rawToken = localStorage.getItem(`jwt`);
        const {userPoints} = await apiFetcher.getPoints(id, rawToken);
        setPoints(userPoints);
    }

    const getToken = () => {
        let rawToken = localStorage.getItem(`jwt`);
        if(!rawToken) return;
        rawToken = parseToken(rawToken)
        setWebToken(rawToken);
        setIsLoggedIn(true);
    }


    const handleLogout = () => {
        if(inProgress){
            alert(`Zakończ rezerwację aby się wylogować`)
            return
        }
        localStorage.removeItem(`jwt`);
        setPoints(null);
        setIsLoggedIn(false);
    }


    const handleSubmit = async () => {
        
        const {confirmed} = await apiFetcher.sendUserData(`login`,userData);
        if(!confirmed) {
            setError(`Nieprawidłowy e-mail lub hasło.`)
            console.log(error);
            return
        }
        setIsLoggedIn(confirmed);
        setIsActivePanel(false);
    }  

    useEffect(() => {
        if(isLoggedIn && webToken && !points){

            getPoints()
        }

    },[webToken, isActivePanel]);

    useEffect(() => {
        if(isLoggedIn) {
            getToken()
        }
    },[isActivePanel, isLoggedIn])







    return(
        <div>
            <div className='user-panel fadeInFromRight' key={isLoggedIn ? "logged-in" : "login-form"}>
            <p onClick={() => setIsActivePanel(false)} id="close-window">&times;</p>
            {isLoggedIn ?
                        <div id="logged-user-info">
                            <p className="user-panel-text">Twoje punkty: <b>{points}</b></p>
                            <p className="user-panel-text">Kod polecenia: <b>{referralCode}</b></p>
                            <p className="user-panel-text" onClick={() => scrollToClass(`discount-offer-header`,14)}>Wymień punkty</p>
                            <p onClick={handleLogout} className="user-panel-text">Wyloguj się.</p>
                        </div>           
                    :         
                        <div id="header-login-form">
                            <input onKeyDown={(e) => e.key === 'Enter' && handleSubmit} onChange={handleInputChange} id="email" placeholder="E-mail" type="text"></input>
                            <input onKeyDown={(e) => e.key === 'Enter' && handleSubmit} onChange={handleInputChange} id="password" placeholder="Hasło" type="password"></input>
                            <button onClick={handleSubmit} id="header-login-button"><h3>Zaloguj się</h3></button>
                            <p style={{color: "red", fontSize: "smaller"}}>{error}</p>
                        </div>
                }
            </div>
        </div>
        
    ) 
}


export default UserPanel;
